import { CreatedProjectResponse, DeleteResponse, ProjectListResponse, ProjectListWithPropertyResponse, ProjectResponse, ProjectTypeResponse } from '../dto/ResDtoRepository';
import { CreateProjectReq, RemoveProjectReq, UpdateProjectReq, UpdateReorderListReq, UpdateProjectListTypeReq, UpdateProjectImgAndTitleReq } from '../dto/ReqDtoRepository';
import { sendApiRequest, sendDeleteApiRequest, sendGetApiRequest } from './apiConfig';


export const getProjectList = async (aui: string): Promise<ProjectListWithPropertyResponse> => {
  return sendGetApiRequest<ProjectListWithPropertyResponse>(`/api/v1/project/list?aui=${aui}`);
};

export const getProjectListForOwner = async (aui: string): Promise<ProjectListWithPropertyResponse> => {
  return sendApiRequest<ProjectListWithPropertyResponse>('get', `/api/v1/project/list/owner?aui=${aui}`);
};

export const getProjectDetail = async (aui: string, projectId: string): Promise<ProjectResponse> => {
  return sendGetApiRequest<ProjectResponse>(`/api/v1/project?aui=${aui}&projectId=${projectId}`);
};

export const getProjectDetailOwner = async (aui: string, projectId: string): Promise<ProjectResponse> => {
  return sendApiRequest<ProjectResponse>('get', `/api/v1/project/owner?aui=${aui}&projectId=${projectId}`);
};

export const createProject = async (aui: string, data: CreateProjectReq): Promise<CreatedProjectResponse> => {
  return sendApiRequest<CreatedProjectResponse>('post', `/api/v1/project?aui=${aui}`, data);
};

export const updateProject = async (aui: string, data: UpdateProjectReq): Promise<ProjectResponse> => {
  return sendApiRequest<ProjectResponse>('put', `/api/v1/project?aui=${aui}`, data);
};

// export const createProjectByImg = async (aui: string, data: PreSignedUrlProjectReq): Promise<PreSignedUrlSingleResponse> => {
//   return sendApiRequest<PreSignedUrlSingleResponse>('post', `/api/v1/project/img?aui=${aui}`, data);
// };

// export const updateProjectTitleAndImg = async (aui: string, data: UpdateProjectImgAndTitleReq): Promise<ProjectResponse> => {
//   return sendApiRequest<ProjectResponse>('put', `/api/v1/project/img?aui=${aui}`, data);
// };

export const updateProjectListType = async (aui: string, data: UpdateProjectListTypeReq): Promise<ProjectTypeResponse> => {
  return sendApiRequest<ProjectTypeResponse>('put', `/api/v1/project-property?aui=${aui}`, data);
};

export const toggleProjectAccess = async (aui: string, data: UpdateProjectReq): Promise<ProjectResponse> => {
  return sendApiRequest<ProjectResponse>('put', `/api/v1/project/toggle-access?aui=${aui}`, data);
};

export const deleteProject = async (aui: string, data: RemoveProjectReq): Promise<DeleteResponse> => {
  return sendDeleteApiRequest<DeleteResponse>(`/api/v1/project?aui=${aui}&projectId=${data.projectId}`);
};

export const reorderProject = async (aui: string, data: UpdateReorderListReq): Promise<ProjectListResponse> => {
  return sendApiRequest<ProjectListResponse>('put', `/api/v1/project/reorder?aui=${aui}`, data);
};